import {createReducer} from '@reduxjs/toolkit';
import {set as setGeometry} from '../actions/geometry.js';
import {
  drawModes,
  modes,
  setDrawMode,
  setLabels,
  setMode,
} from '../actions/ui.js';

export const initialState = {
  drawMode: drawModes.POINT,
  mode: modes.NONE,
  labels: true,
};

const validDrawModes = {};
for (const drawMode in drawModes) {
  validDrawModes[drawModes[drawMode]] = drawMode;
}

const validModes = {};
for (const mode in modes) {
  validModes[modes[mode]] = mode;
}

export default createReducer(initialState, builder => {
  builder.addCase(setDrawMode, (state, {payload: drawMode}) => {
    if (drawMode in validDrawModes) {
      state.drawMode = drawMode;
    }
    return state;
  });

  builder.addCase(setMode, (state, {payload: mode}) => {
    state.mode = mode in validModes ? mode : modes.NONE;
  });

  builder.addCase(setLabels, (state, {payload: labels}) => {
    state.labels = labels;
  });

  builder.addCase(setGeometry, (state, {payload: geometry}) => {
    if (!geometry || state.mode === modes.SELECTION) {
      return state;
    }

    state.mode = modes.SELECTION;
  });
});
